<template>
  <path d="M2.5 2.5L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M13.775 10C14.2926 9.15846 14.5 8.37184 14.5 8C14.5 7 13 3 8 3C7.64972 3 7.31661 3.01963 7 3.05649M11.7913 12C10.8424 12.5901 9.60052 13 8 13C3 13 1.5 9 1.5 8C1.5 7.34413 2.14525 5.39777 4 4.13584"
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M6.58584 9.41421C7.36689 10.1953 8.63322 10.1953 9.41427 9.41421L6.58584 6.58579C5.8048 7.36684 5.8048 8.63316 6.58584 9.41421Z"
    fill="currentColor" />
</template>